import { capitalize, startCase } from 'lodash';
import {
  IOSignalType,
  IOType,
  MonitorIOBindingResult,
} from '../../api/hooks/binding/binding.types';

const getIOFavoriteKey = (io: MonitorIOBindingResult): string => {
  return `${io.group}!!${io.name}!!${io.signalType}!!${io.type}`;
};

const getIOFromFavoriteKey = (
  key: string
): Partial<MonitorIOBindingResult> | void => {
  const io = key.split('!!');
  try {
    return {
      group: io[0],
      name: io[1],
      signalType: io[2] as IOSignalType,
      type: io[3] as IOType,
    };
  } catch (error) {
    // do nothing if can't split key provided
  }
};

const getIOStandardName = (item: Partial<MonitorIOBindingResult>): string => {
  const name = item.name?.split('_')[1];
  const joinedName = `${item.group} ${item.signalType} ${item.type} ${name}`;
  return capitalize(startCase(joinedName));
};

export { getIOFavoriteKey, getIOFromFavoriteKey, getIOStandardName };
